<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [style]="{width: '70vw', height: '80vh'}"
  [draggable]="false"
  [resizable]="false"
  (onHide)="onHide()"
  styleClass="carosello-dialog">

  <ng-template pTemplate="header">
    <div class="dialog-header" style="padding: 0.5rem; display: flex; align-items: center; justify-content: space-between;">
      <h2 style="font-size: 1.2rem; margin: 0;">Immagini della scheda</h2>
      <div class="code-badge" style="background-color: #f5f5f5; padding: 0.25rem 0.5rem; border-radius: 4px; margin-left: 1rem;">
        <span class="code-value" style="font-weight: bold; color: #3a6e75;">{{ codiceScheda }}</span>
      </div>
    </div>
  </ng-template>

  <div class="galleria-container" style="height: calc(100% - 3rem); display: flex; align-items: center; justify-content: center;">
    <div *ngIf="loading" class="loading-container" style="height: 100%; width: 100%; display: flex; align-items: center; justify-content: center;">
      <ng-lottie [options]="options" style="width: 200px; height: 200px;"></ng-lottie>
    </div>

    <div *ngIf="!loading && images.length === 0" class="no-images-container" style="height: 100%; width: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 1rem; padding: 2rem;">
      <ng-lottie [options]="noImagesOptions" style="width: 300px; height: 300px;"></ng-lottie>
      <div class="no-images-message" style="text-align: center;">
        <h3 style="color: #3a6e75; margin-bottom: 0.5rem;">Nessuna immagine disponibile</h3>
        <p style="color: #666; margin: 0;">Non sono state trovate immagini per questa scheda.</p>
        <p *ngIf="!isEnteEsecutore" style="color: #666; margin: 0;">Puoi aggiungere immagini utilizzando la funzione di upload.</p>
      </div>
    </div>

    <div *ngIf="!loading && images.length > 0" style="height: 100%; width: 100%; display: flex; align-items: center; justify-content: center;">
      <p-carousel
        [value]="images"
        [numVisible]="1"
        [numScroll]="1"
        [circular]="true"
        [showNavigators]="true"
        [showIndicators]="true"
        [autoplayInterval]="0"
        styleClass="custom-carousel">

        <ng-template let-item pTemplate="item">
          <div style="height: 60vh; display: flex; align-items: center; justify-content: center; overflow: hidden; padding: 1rem;">
            <img [src]="item.itemImageSrc" [alt]="item.alt" style="max-width: 100%; max-height: 100%; object-fit: contain;"/>
          </div>
        </ng-template>

      </p-carousel>
    </div>
  </div>

  <div class="surface-border border-top-1 opacity-50 mb-3 col-12"></div>

  <!-- <div class="flex justify-content-center gap-3" style="padding: 1rem;">
    <p-button
      icon="pi pi-times"
      (onClick)="conferma(false)"
      label="Chiudi"
      [ngStyle]="{
        'background-color': '#FFE5D9',
        'color': '#9D8189',
        'border': '1px solid #F4ACB7',
        'padding': '0.5rem 1.5rem',
        'border-radius': '6px',
        'box-shadow': '0 2px 4px rgba(0,0,0,0.1)',
        'transition': 'all 0.3s ease',
        'display': 'flex',
        'align-items': 'center',
        'gap': '0.5rem'
      }"
      (mouseenter)="onButtonHover($event, true)"
      (mouseleave)="onButtonHover($event, false)">
    </p-button>

    <p-button
      icon="pi pi-arrow-circle-down"
      (onClick)="conferma(true)"
      label="Scarica Tutti"
      [ngStyle]="{
        'background-color': '#D8E2DC',
        'color': '#4A5759',
        'border': '1px solid #B8D8D8',
        'padding': '0.5rem 1.5rem',
        'border-radius': '6px',
        'box-shadow': '0 2px 4px rgba(0,0,0,0.1)',
        'transition': 'all 0.3s ease',
        'display': 'flex',
        'align-items': 'center',
        'gap': '0.5rem'
      }"
      (mouseenter)="onButtonHover($event, true)"
      (mouseleave)="onButtonHover($event, false)">
    </p-button>
  </div> -->
</p-dialog>
